// src/components/homepage/FeaturedProducts.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const FeaturedProducts = ({ title, products }) => {
  if (!products || products.length === 0) {
    return (
      <section className="py-12 md:py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-left text-gray-800 mb-10 md:mb-12">
            {title || "Featured Products"}
          </h2>
          <p className="text-center text-gray-500">
            No featured products available at the moment.
          </p>
        </div>
      </section>
    );
  }

  const updateSlideHeights = (swiper) => {
    setTimeout(() => {
      if (!swiper.slides || swiper.slides.length === 0) return;

      const slides = swiper.slides;
      let maxHeight = 0;

      for (let i = 0; i < slides.length; i++) {
        slides[i].style.height = "auto";
      }

      for (let i = 0; i < slides.length; i++) {
        if (slides[i].offsetHeight > maxHeight) {
          maxHeight = slides[i].offsetHeight;
        }
      }

      if (maxHeight > 0) {
        for (let i = 0; i < slides.length; i++) {
          slides[i].style.height = `${maxHeight}px`;
        }
      }
    }, 0);
  };

  return (
    <section className="py-12 md:py-16 bg-white">
      {" "}
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-left text-gray-800 mb-10 md:mb-12">
          {title || "Featured Products"}
        </h2>

        <Swiper
          modules={[Navigation]}
          spaceBetween={16}
          slidesPerView={1.75}
          centeredSlides={false}
          loop={false}
          navigation={{
            nextEl: ".swiper-button-next-fp",
            prevEl: ".swiper-button-prev-fp",
            disabledClass: "swiper-button-disabled-custom",
          }}
          pagination={{ clickable: true, el: ".swiper-pagination-fp" }}
          breakpoints={{
            0: {
              slidesPerView: 1.75,
              spaceBetween: 20,
            },
            480: {
              slidesPerView: 2.25,
              spaceBetween: 20,
            },
            850: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 24,
            },
          }}
          onInit={updateSlideHeights}
          onResize={updateSlideHeights}
          className="relative pb-8 md:pb-12"
        >
          {products.map((product) => (
            <SwiperSlide key={product.id}>
              {" "}
              <Link
                to={product.url || "#"}
                className="h-full flex flex-col bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden"
              >
                <div className="w-full h-48 flex-shrink-0 bg-white flex items-center justify-center p-2">
                  {product.product_image && product.product_image.url ? (
                    <img
                      src={`${product.product_image.url}`}
                      alt={
                        product.product_image.alternativeText || product.title
                      }
                      className="max-w-full max-h-full object-contain"
                    />
                  ) : (
                    <div className="text-gray-400 text-sm">No Image</div>
                  )}
                </div>
                <div className="p-4 md:p-5 text-center flex-grow flex flex-col">
                  <div>
                    <h3
                      className="text-lg md:text-xl font-semibold text-gray-800 mb-1"
                      title={product.title}
                    >
                      {product.title}
                    </h3>
                    {product.subtitle && (
                      <p className="text-md md:text-lg text-gray-600">
                        {product.subtitle}
                      </p>
                    )}
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          ))}

          <div className="swiper-button-prev-fp absolute top-1/2 -translate-y-1/2 left-1 z-10 cursor-pointer p-2 bg-white/70 hover:bg-white rounded-full shadow-md hidden md:flex items-center justify-center">
            <svg
              className="w-6 h-6 text-gray-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15 19l-7-7 7-7"
              ></path>
            </svg>
          </div>
          <div className="swiper-button-next-fp absolute top-1/2 -translate-y-1/2 right-1 z-10 cursor-pointer p-2 bg-white/70 hover:bg-white rounded-full shadow-md hidden md:flex items-center justify-center">
            <svg
              className="w-6 h-6 text-gray-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5l7 7-7 7"
              ></path>
            </svg>
          </div>

          <div className="swiper-pagination-fp text-center mt-4 md:hidden"></div>
        </Swiper>
      </div>
      <style jsx global>{`
        .swiper-button-disabled-custom {
          opacity: 0.35;
          cursor: not-allowed;
        }
        .swiper-pagination-fp .swiper-pagination-bullet {
          background-color: #a0aec0; /* gray-500 */
          opacity: 0.8;
          width: 8px;
          height: 8px;
        }
        .swiper-pagination-fp .swiper-pagination-bullet-active {
          background-color: #4a5568; /* gray-700 */
          opacity: 1;
        }
      `}</style>
    </section>
  );
};

export default FeaturedProducts;
